import { actionCreatorFactory } from '../../core/utils/factories';
import {
  AccountingBrowseResponse,
  AccountingBrowseUpdateData,
  AccountingDetails,
  AccountingFinancialTab,
  AccountingSummaryTab,
  PaginatedResponse,
} from '../../models/interfaces';

const actionCreator = actionCreatorFactory('ACCOUNTING');

export namespace AccountingActions {
  export const getAccountingBrowseDataAction = actionCreator.createAsyncAction<
    PaginatedResponse<AccountingBrowseResponse>
  >('GET_ACCOUNTING_BROWSE');

  export const updateAccountingBrowseAction =
    actionCreator.createAsyncAction<AccountingBrowseUpdateData>(
      'UPDATE_ACCOUNTING_BROWSE',
    );

  export const getAccountingDetailsAction =
    actionCreator.createAsyncAction<AccountingDetails>(
      'GET_ACCOUNTING_DETAILS',
    );

  export const getAccountingSummaryTab =
    actionCreator.createAsyncAction<AccountingSummaryTab>(
      'GET_ACCOUNTING_SUMMARY_TAB',
    );

  export const getAccountingFinancialTab =
    actionCreator.createAsyncAction<AccountingFinancialTab>(
      'GET_ACCOUNTING_FINANCIAL_TAB',
    );

  export const setFinancialTabLoading =
    actionCreator.createAsyncAction<boolean>('SET_FINANCIAL_TAB_LOADING');

  export const resetTabsData =
    actionCreator.createAsyncAction('RESET_TABS_DATA');
}
